/**
 * @description 单据操作混入
 * @author: 菩萨蛮
 * @date 2020/2/13 5:50 下午
 * @version V1.0.1
 *
 * 公司的业务千篇一律，复杂的代码好几百行
 */

const orderOperate = {
  props: {
    orderCopy: { type: Object },
    url: { type: String }
  },
  data() {
    return {
      order: {}
    };
  },
  async created() {
    await this.init();
  },
  methods: {
    init() {
    },
    getItem(type) {
      if (type === 'number') {
        return { attribute: 2 };
      }
      return { attribute: 1 };
    },
    close(isPush = false) {
      this.$store.commit('tab/deleteTab', {
        item: this.$store.state.tab.view.title,
        route: this.$route,
        pushUrl: isPush ? this.pushUrl : undefined
      });
    },
    getSubmitData() {
      return this.order.newData;
    },
    submitValueSetting(data) {
      return data;
    },
    validate() {
      return this.order.validate();
    },
    /**
     * 用于各个页面的自有参数构造方法
     */
    localInitData() {
    },
    /**
     * 用于各个组件的自有校验
     * @returns {boolean}
     */
    isLocalPassValidate() {
      return true;
    },
    async submit(needAudit = true) {
      // 必填参数校验
      await this.localInitData();
      const str = this.validate();
      if (!this.utils.isEmpty(str)) {
        this.$message.error(`参数${str}不可为空！`);
        return;
      }
      // 本地参数自定义
      const isLocalPassValidateFlag = this.isLocalPassValidate();
      if (!isLocalPassValidateFlag) {
        return;
      }
      // 获取参数
      let data = this.getSubmitData();
      // 传递的参数设置自定义
      data = await this.submitValueSetting(data);
      await this.goSubmit(needAudit, data);
    },
    setContact() {
      if (!this.utils.isEmpty(this.values) && !this.utils.isEmpty(this.values.contact)) {
        return JSON.parse(this.values.contact).contactName;
      }
      return '';
    }
  }
};

export default orderOperate;
